import MiddlePanel from 'Components/MiddlePanel/MiddlePanel';
import Panel from 'Components/Panel/Panel';
import { useEffect, useState } from 'react';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import Button from 'Components/Button/Button';
import ComboBox from 'Components/ComboBox/ComboBox';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import ReactDataPickerComp from 'Components/ReactDataPicker/ReactDataPickerComp';
import LocalTimeFromInstant from 'Components/LocalTimeFromInstant/LocalTimeFromInstant';
import MandatoryIconField from 'Components/MandatoryIconField';

const ReasonAbsence = ({
    onUpdateResetFilterDay,
    resetFilterDay,
    sectorSelected,
    managerSelected,
    employeeSelected,
    selectedActualDate,
    showReasonAbsence,
    setShowReasonAbsence
}) => {
    const [dtStart, setDtStart] = useState(null)
    const [dtEnd, setDtEnd] = useState(null)
    const [timeStart, setTimeStart] = useState(null)
    const [timeEnd, setTimeEnd] = useState(null)

    const [recordsEmployee, setRecordsEmployee] = useState(null)
    const [selectsEmployeeRegisters, setSelectsEmployeeRegisters] = useState([])
    const [reasonAbsenceSelected, setReasonAbsenceSelected] = useState([])

    const [reasonsAbsences, setReasonsAbsences] = useState(null);

    const attributeList = [
        { name: "id", value: selectsEmployeeRegisters, setter: setSelectsEmployeeRegisters, allowsMultipleRecordsSelected: true },
        { name: "employeeName" },
        { name: "allocatedTime" }
    ];

    useEffect(() => {
        const fetchData = async () => {
            setReasonsAbsences(await ExecuteAxios.api('get', '/absence-reason/get-active-absence-reason-list/'));
        };

        fetchData();
    }, []);

    const panelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100% - 56px)',
        width: '100%'
    }

    useEffect(() => {
        if (showReasonAbsence) {
            resetValues()
        }
    }, [showReasonAbsence]);

    function resetValues() {
        setSelectsEmployeeRegisters([])
        setDtEnd(null)
        setDtStart(null)
        setReasonAbsenceSelected(null)
        setTimeEnd(null)
        setTimeStart(null)
    }

    useEffect(() => {
        if (!showReasonAbsence) {
            return
        }
        getEmployeeRecordsGrid(selectedActualDate)
    }, [showReasonAbsence, sectorSelected, employeeSelected, selectedActualDate]);

    async function getEmployeeRecordsGrid(selectedActualDate) {
        const parameters = {
            sectorId: sectorSelected,
            employeeId: employeeSelected,
            monthYear: new Date(selectedActualDate).toISOString().split('T')[0]
        }
        const employeePanelGrid = await ExecuteAxios.api('get', `/employee-hours-available/get-employees-available-list-for-absence-reason/`, { params: parameters });
        setRecordsEmployee(employeePanelGrid);
    }

    const closeButtonStyle = {
        width: '85px',
        float: 'right',
        color: 'red',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '35px'
    };

    const canSave = timeStart && timeEnd && dtStart && dtEnd;

    const buttonStyle = {
        width: '85px',
        float: 'right',
        color: canSave ? 'green' : '#201b2387',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '35px'
    };

    function closeButton() {
        return (
            <Button
                clickMethod={() => { callMethodsClose() }}
                buttonName={'Fechar'}
                style={closeButtonStyle}
            />
        )
    }

    function callMethodsClose() {
        setShowReasonAbsence(false)
        setRecordsEmployee(null)
        resetValues()
    }

    const detailTimeDateAtributesStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '45%',
        marginRight: '5%',
        marginBottom: '10px'
    };

    const detailAtributesStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '95%',
        marginRight: '5%',
        marginBottom: '10px'
    };

    function reasonAbsenceButton() {
        return (
            <Button
                clickMethod={() => { callToReasonAbsenceSelected() }}
                buttonName={'Confirmar'}
                style={buttonStyle}
                readOnly={!canSave}
            />
        )
    }

    async function callToReasonAbsenceSelected() {
        const response = await ExecuteAxios.api('put', `/employee-hours-available/update-absence-reason-employee-hours-available/`, {
            absenceReasonId: reasonAbsenceSelected,
            employeesIdList: selectsEmployeeRegisters,
            startDateSelected: new Date(dtStart).toISOString().split('T')[0],
            endDateSelected: new Date(dtEnd).toISOString().split('T')[0],
            startTime: LocalTimeFromInstant.getLocalTimeFromInstant(timeStart),
            endTime: LocalTimeFromInstant.getLocalTimeFromInstant(timeEnd)
        });

        if (response) {
            setShowReasonAbsence(false)
            onUpdateResetFilterDay(true)
        }

        return response;
    }

    function getButtonLeft() {
        return (
            <>
                {reasonAbsenceButton()}
                {closeButton()}
            </>
        )
    }

    const reasonsAbsenceOptions = OptionsDataByAttributePath(reasonsAbsences, ['description'], null, true)

    return (
        <MiddlePanel isVisible={showReasonAbsence}>
            <LoadingIndicator loaded={recordsEmployee}>
                <Panel style={{
                    width: '550px',
                    height: '550px',
                    padding: '5px',
                    borderRadius: '10px',
                    backgroundColor: '#f5f5f5',
                    border: '1px solid #ccc',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 30%)'
                }}>
                    <Panel titlePage={'Motivo ausência'}
                        style={panelListStyle}
                        canViewCRUD={true}
                        recordsSelected={selectsEmployeeRegisters}
                        componentRightButtons={getButtonLeft()}
                    >
                        <div style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                                    <div style={detailTimeDateAtributesStyle}>
                                        <div style={{display: 'flex', flexDirection: 'row'}}>
                                            <label>Data início</label>
                                            <MandatoryIconField />
                                        </div>
                                        <ReactDataPickerComp
                                            selected={dtStart}
                                            onChange={(date) => { setDtStart(date) }}
                                            wrapperClassName={'width-full'}
                                            className='validate-attribute width-full cursor-pointer'
                                            setter={setDtStart}
                                        />
                                    </div>
                                    <div style={detailTimeDateAtributesStyle}>
                                        <div style={{display: 'flex', flexDirection: 'row'}}>
                                            <label>Horário início</label>
                                            <MandatoryIconField />
                                        </div>
                                        <ReactDataPickerComp
                                            selected={timeStart}
                                            onChange={(date) => { setTimeStart(date) }}
                                            wrapperClassName={'width-full'}
                                            className='validate-attribute width-full cursor-pointer'
                                            dateFormat={'HH:mm'}
                                            timeFormat={'HH:mm'}
                                            showTimeSelect={true}
                                            showTimeSelectOnly={true}
                                            setter={setTimeStart}
                                        />
                                    </div>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                                    <div style={detailTimeDateAtributesStyle}>
                                        <div style={{display: 'flex', flexDirection: 'row'}}>
                                            <label>Data fim</label>
                                            <MandatoryIconField />
                                        </div>
                                        <ReactDataPickerComp
                                            selected={dtEnd}
                                            onChange={(date) => { setDtEnd(date) }}
                                            wrapperClassName={'width-full'}
                                            className='validate-attribute width-full cursor-pointer'
                                            setter={setDtEnd}
                                        />
                                    </div>
                                    <div style={detailTimeDateAtributesStyle}>
                                        <div style={{display: 'flex', flexDirection: 'row'}}>
                                            <label>Horário fim</label>
                                            <MandatoryIconField />
                                        </div>
                                        <ReactDataPickerComp
                                            selected={timeEnd}
                                            onChange={(date) => { setTimeEnd(date) }}
                                            showMonthYearPicker={false}
                                            wrapperClassName={'width-full'}
                                            className='validate-attribute width-full cursor-pointer'
                                            showTimeSelect={true}
                                            showTimeSelectOnly={true}
                                            setter={setTimeEnd}
                                            dateFormat={'HH:mm'}
                                            timeFormat={'HH:mm'}
                                        />
                                    </div>
                                </div>
                                <div style={detailAtributesStyle}>
                                    <label>Motivo</label>
                                    <ComboBox setAttribute={setReasonAbsenceSelected}
                                        optionsData={reasonsAbsenceOptions}
                                        value={reasonAbsenceSelected}
                                        defaultValue={reasonAbsenceSelected}
                                        readOnly={false}
                                        disabled={false}
                                    />
                                </div>
                            </div>
                            <div style={{ height: '100%', width: '50%' }}>
                                <PanelListDefault
                                    onUpdateIdSelected={setSelectsEmployeeRegisters}
                                    idsSelected={selectsEmployeeRegisters}
                                    data={recordsEmployee}
                                    attributeList={attributeList}
                                />
                            </div>
                        </div>

                    </Panel>
                </Panel>
            </LoadingIndicator>
        </MiddlePanel >
    );
}

export default ReasonAbsence;
